module.exports = __webpack_public_path__ + "img/iph.5ce3c715.png";